// extracted by mini-css-extract-plugin
export var modal = "_kx-0";